import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Process } from "../components/Process";
import { OurWorkTeaser } from "../components/OurWorkTeaser";
import { PricingSummary } from "../components/PricingSummary";
import { ContactBlock } from "../components/ContactBlock";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      setTimeout(() => document.getElementById(target)?.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <Process />
      <OurWorkTeaser />
      <PricingSummary />
      <section id="contact" className="px-5 md:px-10 py-10 md:py-16 scroll-mt-24">
        <div className="max-w-[1440px] mx-auto">
          <ContactBlock />
        </div>
      </section>
    </>
  );
}
